export default __webpack_public_path__ + "static/media/therapy_brain.238fdf8a.png";